export default "__VITE_ASSET__7fe26bc6__"